<template>
  <div>
    <div class="flex-def" style="width: 100%">
      <el-input :value="showValue.id > 0 ? `#${showValue.id}:${showValue.title}` : ''" disabled></el-input>
      <el-button @click="dialogTableVisible=true">选择卡券</el-button>
    </div>
    <el-dialog append-to-body title="选择卡券" :visible.sync="dialogTableVisible">
      <el-table :data="list">
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="title" label="标题" ></el-table-column>
        <el-table-column label="操作">
          <template #default="s">
            <el-button @click="choose(s.row)">选中</el-button>
          </template>
        </el-table-column>
        <template #append>
          <el-pagination style="padding: .5rem" background layout="total,prev, pager,next"
                         :total="total" :page-size="15" :current-page="page" @current-change="pageChange">
          </el-pagination>
        </template>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CouponChooseWithMerchant",
  model:{
    prop:"modelVal",
    event:'valChange'
  },
  props:{
    merchantId:{
      type:Number,
      default: 0
    },
    modelVal: {
      type:Number,
      default:0,
    },
  },
  data(){
    return{
      dialogTableVisible:false,
      page:1,
      list:[],
      total:0,
      showValue:{
        id:0,
        title:"",
      },
      value:0,
    }
  },
  watch:{
    modelVal:{
      handler:"modelValChanged",
      immediate:true,
      deep:true,
    },
    value(e){
      this.$emit('valChange',e);
    },
    merchantId:{
      immediate:true,
      deep:true,
      handler:"merchantIDChanged"
    },
  },
  mounted() {

  },
  methods:{
    modelValChanged(now,old){
      if(!old && now > 0){
        this.$u.api.card.merchantCouponOne({id:now}).then(res=>{
          this.showValue = res;
        })
      }
      this.value = this.modelVal;
    },
    merchantIDChanged(){
      if (this.merchantId > 0){
        this.load();
      }
    },
    choose(e){
      this.showValue = e;
      this.value = e.id;
      this.dialogTableVisible =false;
      this.$emit("change",e);
    },
    pageChange(e) {
      this.page = e;
      this.load();
    },
    load(){
      this.$u.api.card.merchantCouponSearch({
        page:this.page,
        merchant_id:this.merchantId,
      }).then(res=>{
        this.list = res.list;
        this.total = res.total;
      })
    }
  }
}
</script>

<style scoped>

</style>